import { render, staticRenderFns } from "./account-detail.vue?vue&type=template&id=7c25c182"
import script from "./account-detail.vue?vue&type=script&lang=ts"
export * from "./account-detail.vue?vue&type=script&lang=ts"
import style0 from "./account-detail.vue?vue&type=style&index=0&id=7c25c182&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports